import { EditItem, IEditItem } from "../common/editItem";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface IAppReportTemplateEditItem extends IEditItem {
    code: string;
    comment: string;
    dataSchema: string;
    activeState: number;
    modifyUser: IModifyUser;
}

export class AppReportTemplateEditItem extends EditItem implements IAppReportTemplateEditItem {
    code: string;
    comment: string;
    dataSchema: string;
    activeState: number;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IAppReportTemplateEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.dataSchema = obj && obj.dataSchema || "";
        this.activeState = obj && obj.activeState || 0;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}